/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {fetchCorrosionAlertsChartData} from "../../../api/alertsApi";


const sensor_filter = `sensor.excludeFromUi = 0`;

function useGetCorrosionAlertsCount() {

    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const filter = sessionStorage.getItem('alertApplyfilter');
    console.log("Filter in useGetCorrosionAlertsCount:", filter);
    const finalFilter = filter ? `${filter} AND ${sensor_filter}` : sensor_filter;
    
    useEffect(() => {
        setLoading(true);
        
        fetchCorrosionAlertsChartData(finalFilter).then(data => {
            var result = {
                    category: [],
                    count: []
                }
            if (data.length > 0){
                
                data.map(item => {
                    result["category"].push(item.category);
                    result["count"].push(item.count);
                });
            }
            setData(result);
        }).catch(error => {
            console.error(error);
            toast.error(`Cannot fetch Corrosion Alerts Count`);
            setError(error);
        }).finally(() => {
            setLoading(false);
        });
    }, [
        filter
    ]);

    return { data, loading, error };
}

export default useGetCorrosionAlertsCount;